import { render, staticRenderFns } from "./AddEditDamages.vue?vue&type=template&id=2fa58546"
import script from "./AddEditDamages.vue?vue&type=script&lang=js"
export * from "./AddEditDamages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports